module.exports = __webpack_public_path__ + "static/media/payment.eca46826.svg";